import React, { useRef, useCallback } from 'react';

import { Card, Form, Button } from 'react-bootstrap';

import { updateDato } from '../funzioni';

function UploadFile(props) {
  const { descrizione, modificabile, idDato } = props;

  const fileInputRef = useRef(null);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleFileSubmission = useCallback(async () => {
    if (!fileInputRef.current) return;

    const file = fileInputRef.current.files[0];

    if (!file) {
      alert('Please, select a file to upload');
      return;
    }

    const result = await toBase64(file).catch((e) => Error(e));

    if (result instanceof Error) {
      alert('errore nel caricare il file');
      console.error(result);
      return;
    }

    updateDato(idDato, result, 'file');
  }, [fileInputRef]);

  return (
    <>
      <Card border className="border-primary h-100">
        <Card.Header className="p-3">
          <Card.Title className="m-0">{descrizione}</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-end">
            <Form.Group controlId="formFile" className="w-100 me-4">
              <Form.Label>Select a file to upload (pdf only)</Form.Label>
              <Form.Control type="file" accept="application/pdf" ref={fileInputRef} disabled={!modificabile} />
            </Form.Group>
            <Button onClick={handleFileSubmission} disabled={!modificabile}>
              Upload
            </Button>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default UploadFile;
